module.exports = __webpack_public_path__ + "static/aldi-31ec6fc1b02b8cc1e0d9b22b297d3386.png";